module.exports = __webpack_public_path__ + "static/media/hydra-logo.92fbca59.png";